module.exports = __webpack_public_path__ + "img/E5.4c28852b.png";